package org.teddapp.project.sync

import com.tedd.db.TeddDatabase

/**
 * Les sous-dépenses dans le moteur de synchronisation. Le réel de leur ligne voyage avec
 * la ligne elle-même : l'appareil qui ajoute une sous-dépense recalcule et pousse les deux.
 */
internal object ExpenseEntrySyncOps {

    fun dirtyQuery(entity: EntityKind, db: TeddDatabase): app.cash.sqldelight.Query<*> = db.expenseEntryQueries.selectDirty()

    fun selectDirty(entity: EntityKind, db: TeddDatabase): List<RemoteRow> =
        db.expenseEntryQueries.selectDirty().executeAsList().map { row(it) }

    fun selectAll(entity: EntityKind, db: TeddDatabase): List<RemoteRow> =
        db.expenseEntryQueries.selectAll().executeAsList().map { row(it) }

    fun markSynced(entity: EntityKind, db: TeddDatabase, id: String, updatedAt: Long, syncedAt: Long) {
        db.expenseEntryQueries.markSynced(syncedAt, id, updatedAt)
    }

    fun selectByIdAnyState(entity: EntityKind, db: TeddDatabase, id: String): LocalSnapshot? =
        db.expenseEntryQueries.selectByIdAnyState(id).executeAsOneOrNull()?.let { LocalSnapshot(it.updated_at, it.is_deleted == 1L) }

    fun insertFromRemote(entity: EntityKind, db: TeddDatabase, row: RemoteRow) {
        val p = row.payload
        db.expenseEntryQueries.insert(
            row.id,
            p.str("item_id") ?: "",
            p.str("label") ?: "",
            p.long("amount") ?: 0L,
            p.str("date"),
            p.str("note"),
            p.str("tx_id"),
            p.long("order_index") ?: 0L,
            p.long("created_at") ?: row.updatedAt,
            row.updatedAt,
        )
    }

    fun updateFromRemote(entity: EntityKind, db: TeddDatabase, row: RemoteRow) {
        val p = row.payload
        db.expenseEntryQueries.updateFromRemote(
            p.str("item_id") ?: "",
            p.str("label") ?: "",
            p.long("amount") ?: 0L,
            p.str("date"),
            p.str("note"),
            p.str("tx_id"),
            p.long("order_index") ?: 0L,
            row.updatedAt,
            row.id,
        )
    }

    fun softDeleteFromRemote(entity: EntityKind, db: TeddDatabase, row: RemoteRow, deletedAt: Long) {
        db.expenseEntryQueries.softDelete(deletedAt, row.updatedAt, row.id)
    }

    fun restoreIfDeleted(entity: EntityKind, db: TeddDatabase, row: RemoteRow) {
        db.expenseEntryQueries.restore(row.updatedAt, row.id)
    }

    private fun row(it: com.tedd.db.Expense_entry) = RemoteRow(it.id, it.updated_at, it.is_deleted == 1L, it.deleted_at, mapOf(
        "item_id" to it.item_id,
        "label" to it.label,
        "amount" to it.amount,
        "date" to it.date,
        "note" to it.note,
        "tx_id" to it.tx_id,
        "order_index" to it.order_index,
        "created_at" to it.created_at,
    ))
}
